import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import DomainGroupingModalContainer from '../system/domain-grouping/domain-grouping-modal-container';
import DomainDetailsModalNotesContainer from '../domain-details/domain-details-modal-notes-container';
import VerificationBySenderModalContainer from '../sender-verification/verification-by-sender-modal-container';
import VerificationByDomainModalContainer from '../sender-verification/verification-by-domain-modal-container';
import WhoisModalContainer from '../whois/whois-modal-container';

import {
    isModalOpenSelector,
    modalTypeSelector
} from '../common/selectors/modal-selectors';
import {
    closeModal
} from '../common/actions/modal-action-creators';

const modalTypeMap = {
    addDomainDetailNotes: DomainDetailsModalNotesContainer,
    domainGrouping: DomainGroupingModalContainer,
    verifiedByDomain: VerificationByDomainModalContainer,
    verifiedBySender: VerificationBySenderModalContainer,
    whois: WhoisModalContainer
};

export class ModalContainer extends Component{
    render(){
        const { open, modalType, closeModal } = this.props;
        const Modal = modalTypeMap[modalType] || VerificationBySenderModalContainer;
        return (
            <Modal open={open} onClose={closeModal}/>
        );
    }
};

/* istanbul ignore next */
function mapStateToProps( state ){
    return {
        modalType: modalTypeSelector( state ),
        open: isModalOpenSelector( state ),
    };
}

ModalContainer.propTypes = {
    closeModal: PropTypes.func.isRequired,
    modalType: PropTypes.oneOf( [...Object.keys( modalTypeMap ), null] ),
    open: PropTypes.bool.isRequired,
};

export default connect(
    mapStateToProps,
    { closeModal }
)( ModalContainer );
